import React from "react";
import { Link } from "react-router-dom";

export default function NewElectricityAgreementConfirmation({ isResaleOffer, isChangingPackage }: { isResaleOffer: boolean; isChangingPackage: boolean; }) {

    const title = isResaleOffer ? 'Täname päringu eest!' : isChangingPackage ? 'Paketi muutmine oli edukas!' : 'Lepingu sõlmimine oli edukas!';
    const contentText = isResaleOffer ?
        'Vaatame teie andmed üle ning edastame teile pakkumise peagi e-postiga.' :
        'Meil on hea meel, et olete valinud Terminali teenused. Lepingu leiate alati mugavalt iseteenindusest.';

    return (
        <div className="container new-electricity-agreement__confirmation-container">
            <div className="agreement-confirmed"><h1>{ title }</h1></div>
            <div className="row mr-0 ml-0 mb-5">
                <p> { contentText }</p>
            </div>

            <div>
                <Link to='/esileht' className="btn btn-primary btn-lg text-left">
                    Suundu tagasi töölauale
                </Link>
            </div>
        </div>
    )
}
